/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useEffect, useState } from "react";
//#endregion
//#region Components
import HelmetUTP from "components/HelmetUTP/HelmetUTP";
import Preloader from "components/Preloader/Preloader";
import ToastMessage from "components/ToastMessage/ToastMessage";
import EmptyView from "views/components/EmptyView/EmptyView";
import ListComponent from "./ListComponent/ListComponent";
//#endregion
//#region Services
import { requestUserHasEvents } from "services/events/aboutEvents";
import { currentUserLocalStorage } from "services/storage/general";
//#endregion
//#region Utils
import { USER_ROLES } from "config/userPermissions";
import { CREATE_EVENT_DROPDOWN_OPTIONS } from "./utils/constants";
//#endregion

const EventListView = ({ userRole }) => {
	const isTeacherUser = (userRole === USER_ROLES.EVENTOS_DOCENTE || userRole === USER_ROLES.REF_ACAD_TUTOR);
	const hasReportWaitlist = (userRole === USER_ROLES.SUPERADMIN || userRole === USER_ROLES.COORDINADOR_EVENTOS_ESPACIOS_UNIVERSITARIOS)
	//#region States
	const [currentUserHasEvents, setCurrentUserHasEvents] = useState(null);
	const [toastMessage, setToastMessage] = useState({
		hidden: true,
		message: "-",
	});
	//#endregion
	//#region Effects
	useEffect(() => {
		verifyIfCurrentUserHasEvents();
	}, [userRole]);
	//#endregion
	//#region Functions
	const verifyIfCurrentUserHasEvents = async () => {
		if (!userRole) return;
		const { id: userCode } = currentUserLocalStorage.get() || { id: null };
		if (!userCode) return;
		const hasEvents = await requestUserHasEvents(userCode, isTeacherUser);
		setCurrentUserHasEvents(hasEvents);
	};	
	//#endregion
	return (
		<>
			<HelmetUTP title="Eventos" />
			<ToastMessage
				{...toastMessage}
				toggleHidden={() =>
					setToastMessage({ ...toastMessage, hidden: true })
				}
			/>
			<Preloader
				message="Cargando..."
				hidden={currentUserHasEvents !== null}
			/>
			{currentUserHasEvents !== null &&
				(currentUserHasEvents ? (
					<ListComponent
						userRole={userRole}
						isTeacherUser={isTeacherUser}
						setToastMessage={setToastMessage}
						hasReportWaitlist={hasReportWaitlist}
					/>
				) : (
					<EmptyView
						isCoordinator={!isTeacherUser}
						dropDownButtonProps={
							CREATE_EVENT_DROPDOWN_OPTIONS
						}
						as="ponente"
					/>
				))}
		</>
	);
};

export default EventListView;
